import React from 'react';


class SelectionIndicator extends React.Component {

  render() {
    let className = 'selection-indicator';
    if (this.props.enabled) {
      className += ' selection-indicator-enabled';
    } else if (this.props.highlight) {
      className += ' selection-indicator-highlight';
    }
    return (
      <div className={className}>
        <div className='selection-indicator-border'>
          <div className='selection-indicator-inner-circle'></div>
        </div>
      </div>
    );
  }
}


class SelectionIndicators extends React.Component {

  render() {
    let selectionCounter = this.props.selectionCounter;
    return (
      <div className='selection-indicator-container'>
        <div className='selection-indicator-inner-container'>
          <SelectionIndicator enabled={selectionCounter>=1} highlight={selectionCounter==0}></SelectionIndicator>
          <SelectionIndicator enabled={selectionCounter>=2} highlight={selectionCounter==1}></SelectionIndicator>
          <SelectionIndicator enabled={selectionCounter>=3} highlight={selectionCounter==2}></SelectionIndicator>
        </div>
        <span>{ this.props.text }</span>
      </div>
    );
  }
}

export default SelectionIndicators;


